import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React from "react";
import { useTheme, useMediaQuery } from "componentLibrary";
import { IconConstants } from "componentLibrary/MuiComponentWrappers/Icon/IconConstants";
import RaiseButton, { ButtonVariantEnum, ButtonSizeEnum } from "componentLibrary/MuiComponentWrappers/Button/RaiseButton";
import LoginFormContentContainer from "./LoginFormContentContainer";
import * as Yup from "yup";
import { jsx as _jsx } from "react/jsx-runtime";
var WorkplaceLoginFormWithOTP = function WorkplaceLoginFormWithOTP(_ref) {
  var _context;
  var email = _ref.email,
    showPassword = _ref.showPassword,
    loading = _ref.loading,
    otpButtonLoading = _ref.otpButtonLoading,
    isError = _ref.isError,
    errorMessage = _ref.errorMessage,
    handleSubmit = _ref.handleSubmit,
    handleRequestOTP = _ref.handleRequestOTP,
    handleEmailChange = _ref.handleEmailChange,
    additionalFormLinks = _ref.additionalFormLinks;
  var theme = useTheme();
  var isMobile = useMediaQuery(theme.breakpoints.down("smMd"));
  var ValidationSchema = Yup.object().shape({
    usernameLogin: Yup.string().nullable().email("Please enter a valid email."),
    passwordLogin: Yup.string().nullable()
  });
  var otpButton = /*#__PURE__*/_jsx(RaiseButton, {
    variant: showPassword ? ButtonVariantEnum.secondary : ButtonVariantEnum.primary,
    size: isMobile ? ButtonSizeEnum.medium : ButtonSizeEnum.large,
    onClick: handleRequestOTP,
    leadingIcon: otpButtonLoading ? IconConstants.SPINNER : undefined,
    disabled: otpButtonLoading,
    setToFill: true,
    children: "Get One-Time Password (OTP)"
  });
  return /*#__PURE__*/_jsx(LoginFormContentContainer, {
    header: "Sign in",
    formElements: _concatInstanceProperty(_context = [{
      id: "usernameLogin",
      initialValue: email,
      label: "Email",
      placeholder: "Enter your email"
    }]).call(_context, _toConsumableArray(showPassword ? [{
      id: "passwordLogin",
      initialValue: "",
      label: "Enter Password",
      placeholder: "Enter your password",
      type: "password"
    }] : [])),
    ValidationSchema: ValidationSchema,
    handleSubmit: handleSubmit,
    loading: loading,
    isError: isError,
    errorMessage: errorMessage,
    buttonText: "Sign in",
    additionalFormLinks: additionalFormLinks,
    additionalButton: otpButton,
    hidePrimaryButton: !showPassword,
    onEmailChange: handleEmailChange
  });
};
export default WorkplaceLoginFormWithOTP;